module.exports = __webpack_public_path__ + "static/media/conga-wordmark-purple.6048de48.svg";